/* eslint-disable no-magic-numbers */
export const validateCPF = (cpf: string): boolean => {
  const cleanedCPF = cpf.replace(/\D/g, '');

  if (cleanedCPF.length !== 11) {
    return false;
  }

  const invalidCPFRegex = /(\d)\1{10}/;
  if (invalidCPFRegex.test(cleanedCPF)) {
    return false;
  }

  let sum = 0;
  let remainder: number;

  for (let i = 1; i <= 9; i += 1) {
    // eslint-disable-next-line no-magic-numbers
    sum += parseInt(cleanedCPF.substring(i - 1, i), 10) * (11 - i);
  }

  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }

  if (remainder !== parseInt(cleanedCPF.substring(9, 10), 10)) {
    return false;
  }

  sum = 0;
  for (let i = 1; i <= 10; i += 1) {
    sum += parseInt(cleanedCPF.substring(i - 1, i), 10) * (12 - i);
  }

  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }

  if (remainder !== parseInt(cleanedCPF.substring(10, 11), 10)) {
    return false;
  }

  return true;
};
